export const SM = {
  gezinme: 'Çalışma alanı gezinmesi', mobil: 'Mobil ana gezinme',
  sabitle: 'Menüyü sabitle', birak: 'Menü sabitliğini kaldır',
  alanlar: 'Çalışma alanları', yonetim: 'Yönetim', genel: 'Genel',
  fazla: 'Daha fazla', kapat: 'Menüyü kapat', alt: 'alt menüsü',
  geciken: (n: number) => `${n} geciken iş`,
} as const;
